(function ($) {
  'use strict';

  $(function () {
    var config = window.goeliaCartIncentiveConfig;

    if (!config || !window.Shopify || !Shopify.routes) return;

    var marketRoot = String(Shopify.routes.root || '').toLowerCase();
    var isMarketExcluded = config.marketEnabled === false ||
      marketRoot.indexOf('-au') > -1 ||
      marketRoot.indexOf('-sg') > -1 ||
      marketRoot.indexOf('-es') > -1;

    var GIFT_DURATION_IN_MS = (Number(config.countdownSeconds) || 1200) * 1000;
    var FREQUENCY_IN_MS = (Number(config.frequencyHours) || 24) * 60 * 60 * 1000;
    var CART_MUTATION_DEBOUNCE_MS = 1000;
    var CART_RERENDER_DEDUP_MS = 5000;
    var OFFER_SHOWN_AT_KEY = 'goelia_cart_incentive_shown_at';
    var GIFT_ADDED_AT_KEY = 'goelia_cart_incentive_gift_added_at';
    var giftProductRequest = null;
    var checkTimer = null;
    var scheduledCart = null;
    var countdownTimer = null;
    var giftExpiryTimer = null;
    var isChecking = false;
    var isAddingGift = false;
    var isRemovingGift = false;
    var suppressedForPage = false;
    var lastAjaxCartMutationAt = 0;
    var storageFallback = {};
    var $document = $(document);
    var $body = $('body');
    var isTestMode = getQueryParam('cart_incentive_test') === '1';
    // var isTestMode = true;

    if (isMarketExcluded || true) {
      removeGiftForExcludedMarket();
      return;
    }

    function getQueryParam(name) {
      var value = '';
      var query = window.location.search.replace(/^\?/, '').split('&');

      $.each(query, function (index, item) {
        var parts = item.split('=');
        var key = decodeURIComponent(parts.shift() || '');

        if (key === name) {
          value = decodeURIComponent(parts.join('=') || '');
          return false;
        }
      });

      return value;
    }

    function getStoredNumber(key) {
      try {
        return Number(window.localStorage.getItem(key) || 0);
      } catch (error) {
        return Number(storageFallback[key] || 0);
      }
    }

    function setStoredNumber(key, value) {
      var numberValue = Number(value) || Date.now();
      storageFallback[key] = numberValue;

      try {
        window.localStorage.setItem(key, String(numberValue));
      } catch (error) {
        // The in-memory value keeps the current page functional when storage is unavailable.
      }
    }

    function removeStoredValue(key) {
      delete storageFallback[key];

      try {
        window.localStorage.removeItem(key);
      } catch (error) {
        // The in-memory fallback has still been cleared.
      }
    }

    function wasOfferedRecently() {
      if (isTestMode) return false;

      var shownAt = getStoredNumber(OFFER_SHOWN_AT_KEY);
      return shownAt > 0 && Date.now() - shownAt < FREQUENCY_IN_MS;
    }

    function getActiveGiftAddedAt() {
      var addedAt = getStoredNumber(GIFT_ADDED_AT_KEY);

      return addedAt > 0 && Date.now() - addedAt < GIFT_DURATION_IN_MS ? addedAt : 0;
    }

    function isOfferFrequencyBlocked() {
      // A temporarily removed gift may be restored during its original countdown.
      return wasOfferedRecently() && !getActiveGiftAddedAt();
    }

    function markOfferShown(timestamp) {
      if (isTestMode) return;
      setStoredNumber(OFFER_SHOWN_AT_KEY, timestamp || Date.now());
    }

    function route(path) {
      var root = Shopify.routes.root || '/';
      return root.replace(/\/$/, '') + '/' + String(path || '').replace(/^\//, '');
    }

    function getCart() {
      if ($.isFunction(Shopify.requestCart)) {
        return Shopify.requestCart();
      }

      return $.ajax({
        type: 'GET',
        url: route('cart.js'),
        dataType: 'json',
        cache: false
      });
    }

    function isCartSnapshot(cart) {
      return !!cart && Array.isArray(cart.items) && typeof cart.total_price === 'number';
    }

    function getCurrencyRate() {
      var rate = Number(Shopify.currency && Shopify.currency.rate);
      return rate > 0 ? rate : 1;
    }

    function getItemProperties(item) {
      return (item && item.properties) || {};
    }

    function isExcludedItem(item) {
      var properties = getItemProperties(item);
      return properties._gift_product === 'yes' || properties._is_complimentary_gift === 'yes';
    }

    function isTargetGift(item) {
      var properties = getItemProperties(item);
      var matchesProduct = String(item && item.handle) === String(config.giftProductHandle) ||
        Number(item && item.product_id) === Number(config.giftProductId) ||
        Number(item && item.variant_id) === Number(config.giftVariantId);

      return properties._gift_product === 'yes' && matchesProduct;
    }

    function getTargetGiftItems(cart) {
      return $.grep((cart && cart.items) || [], isTargetGift);
    }

    function removeGiftForExcludedMarket() {
      var didUpdateCart = false;
      var cleanupRequest;

      removeStoredValue(GIFT_ADDED_AT_KEY);
      stopGiftCountdown();

      function performCleanup() {
        var latestCartRequest = $.isFunction(Shopify.requestFreshCart)
          ? Shopify.requestFreshCart()
          : getCart();

        return Promise.resolve(latestCartRequest).then(function (latestCart) {
          var updates = {};

          $.each(getTargetGiftItems(latestCart), function (index, item) {
            var itemIdentifier = item.key || item.variant_id;
            if (itemIdentifier) updates[itemIdentifier] = 0;
          });

          if (!Object.keys(updates).length) return latestCart;

          return Promise.resolve($.ajax({
            type: 'POST',
            url: route('cart/update.js'),
            cartIncentiveRequest: true,
            data: JSON.stringify({ updates: updates }),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json',
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          })).then(function (updatedCart) {
            didUpdateCart = true;
            return updatedCart;
          });
        });
      }

      cleanupRequest = $.isFunction(Shopify.enqueueCartMutation)
        ? Shopify.enqueueCartMutation(performCleanup)
        : performCleanup();

      Promise.resolve(cleanupRequest)
        .then(function (updatedCart) {
          if (didUpdateCart) refreshCart(updatedCart);
        })
        .catch(function (xhr) {
          console.warn(
            '[Cart incentive gift] Unable to remove the gift for the excluded market.',
            getAjaxError(xhr, 'Please try again.')
          );
        });
    }

    function getEligibleCartStats(cart) {
      var quantity = 0;
      var totalInCents = 0;

      $.each((cart && cart.items) || [], function (index, item) {
        if (isExcludedItem(item)) return;

        quantity += Number(item.quantity) || 0;
        totalInCents += Number(
          item.final_line_price != null ? item.final_line_price : item.line_price
        ) || 0;
      });

      return {
        quantity: quantity,
        usdAmount: totalInCents / 100 / getCurrencyRate()
      };
    }

    function qualifiesForGift(cart) {
      var stats = getEligibleCartStats(cart);
      return stats.quantity >= (Number(config.minimumQuantity) || 2) &&
        stats.usdAmount > (Number(config.minimumUsdAmount) || 50);
    }

    function getGiftVariant(product) {
      var variants = (product && product.variants) || [];
      var requestedSku = String(config.giftSku || '').toUpperCase();
      var matchedVariant = null;

      $.each(variants, function (index, variant) {
        if (String(variant.sku || '').toUpperCase() === requestedSku) {
          matchedVariant = variant;
          return false;
        }
      });

      if (matchedVariant) return matchedVariant;

      matchedVariant = $.grep(variants, function (variant) {
        return variant.available;
      })[0];

      return matchedVariant || variants[0] || null;
    }

    function loadGiftProduct() {
      var deferred;

      if (giftProductRequest) return giftProductRequest;

      deferred = $.Deferred();
      giftProductRequest = deferred.promise();

      $.ajax({
        type: 'GET',
        url: route(config.giftProductPath),
        dataType: 'json',
        cache: false,
        timeout: 10000
      })
        .done(function (product) {
          var variant = getGiftVariant(product);

          if (product && product.id) config.giftProductId = Number(product.id);
          if (variant && variant.id) config.giftVariantId = Number(variant.id);
          deferred.resolve(product, variant);
        })
        .fail(function (xhr) {
          console.warn('[Cart incentive gift] Unable to load the gift product.', xhr);
          deferred.resolve(null, null);
        });

      return giftProductRequest;
    }

    function padTime(value) {
      return value < 10 ? '0' + value : String(value);
    }

    function formatCountdown(milliseconds) {
      var totalSeconds = Math.max(Math.ceil(milliseconds / 1000), 0);
      var hours = Math.floor(totalSeconds / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      return padTime(hours) + ':' + padTime(minutes) + ':' + padTime(seconds);
    }

    function renderCountdown(addedAt) {
      var remainingTime = GIFT_DURATION_IN_MS - (Date.now() - Number(addedAt));
      var countdownText = formatCountdown(remainingTime);

      $('[data-cart-incentive-countdown]').text(countdownText);
      $('[data-cart-incentive-gift]').attr(
        'aria-label',
        'Free gift. Gift ends in ' + countdownText
      );

      return remainingTime;
    }

    function stopGiftCountdown() {
      if (countdownTimer) window.clearInterval(countdownTimer);
      if (giftExpiryTimer) window.clearTimeout(giftExpiryTimer);
      countdownTimer = null;
      giftExpiryTimer = null;
    }

    function startGiftCountdown(addedAt) {
      var remainingTime;

      stopGiftCountdown();
      remainingTime = renderCountdown(addedAt);

      if (remainingTime <= 0) {
        scheduleGiftCheck(0);
        return;
      }

      countdownTimer = window.setInterval(function () {
        renderCountdown(addedAt);
      }, 1000);

      giftExpiryTimer = window.setTimeout(function () {
        stopGiftCountdown();
        scheduleGiftCheck(0);
      }, remainingTime);
    }

    function refreshCart(cart) {
      $document.trigger('cart:rerender', [cart]);

      if (!window.halo) return;

      if ($body.hasClass('template-cart') && $.isFunction(window.halo.updateCart)) {
        window.halo.updateCart(cart, 'No');
      } else if ($.isFunction(window.halo.updateSidebarCart)) {
        window.halo.updateSidebarCart(cart, 'No');
      }
    }

    function getAjaxError(xhr, fallbackMessage) {
      var response = xhr && xhr.responseJSON;

      if (!response && xhr && xhr.responseText) {
        try {
          response = $.parseJSON(xhr.responseText);
        } catch (error) {
          response = {};
        }
      }

      return response && response.description ? response.description : fallbackMessage;
    }

    function removeTargetGift(cart, reason, options) {
      var removalOptions = options || {};
      var shouldSuppress = removalOptions.suppress !== false;
      var shouldClearAddedAt = removalOptions.clearAddedAt !== false;
      var didUpdateCart = false;
      var removalRequest;

      if (!getTargetGiftItems(cart).length || isRemovingGift) return;

      isRemovingGift = true;
      if (shouldSuppress) suppressedForPage = true;

      function performRemoval() {
        var latestCartRequest = $.isFunction(Shopify.requestFreshCart)
          ? Shopify.requestFreshCart()
          : getCart();

        return Promise.resolve(latestCartRequest).then(function (latestCart) {
          var updates = {};

          $.each(getTargetGiftItems(latestCart), function (index, item) {
            var itemIdentifier = item.key || item.variant_id;
            if (itemIdentifier) updates[itemIdentifier] = 0;
          });

          // Another queued routine may already have removed the gift.
          if (!Object.keys(updates).length) return latestCart;

          return Promise.resolve($.ajax({
            type: 'POST',
            url: route('cart/update.js'),
            cartIncentiveRequest: true,
            data: JSON.stringify({ updates: updates }),
            contentType: 'application/json; charset=UTF-8',
            dataType: 'json',
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          })).then(function (updatedCart) {
            didUpdateCart = true;
            return updatedCart;
          });
        });
      }

      removalRequest = $.isFunction(Shopify.enqueueCartMutation)
        ? Shopify.enqueueCartMutation(performRemoval)
        : performRemoval();

      Promise.resolve(removalRequest)
        .then(function (updatedCart) {
          if (shouldClearAddedAt) removeStoredValue(GIFT_ADDED_AT_KEY);
          stopGiftCountdown();
          if (didUpdateCart) refreshCart(updatedCart);
        })
        .catch(function (xhr) {
          console.warn(
            '[Cart incentive gift] Unable to remove the gift (' + reason + ').',
            getAjaxError(xhr, 'Please try again.')
          );
          scheduleGiftCheck(5000);
        })
        .then(function () {
          isRemovingGift = false;
          $('[data-cart-incentive-gift]').removeClass('is-loading');
        }, function () {
          isRemovingGift = false;
          $('[data-cart-incentive-gift]').removeClass('is-loading');
        });
    }

    function addTargetGift(cart) {
      if (isAddingGift || isRemovingGift || suppressedForPage || isOfferFrequencyBlocked()) return;

      isAddingGift = true;

      loadGiftProduct().done(function (product, variant) {
        var variantId = Number(variant && variant.id) || Number(config.giftVariantId);

        if (!variantId || (variant && variant.available === false)) {
          isAddingGift = false;
          console.warn('[Cart incentive gift] The configured gift variant is unavailable.');
          return;
        }

        function submitGift(latestCart) {
          if (
            getTargetGiftItems(latestCart).length ||
            !qualifiesForGift(latestCart) ||
            suppressedForPage ||
            isOfferFrequencyBlocked()
          ) {
            isAddingGift = false;
            return;
          }

          function performAdd() {
            var latestCartRequest = $.isFunction(Shopify.requestFreshCart)
              ? Shopify.requestFreshCart()
              : getCart();

            return Promise.resolve(latestCartRequest).then(function (currentCart) {
              if (
                getTargetGiftItems(currentCart).length ||
                !qualifiesForGift(currentCart) ||
                suppressedForPage ||
                isOfferFrequencyBlocked()
              ) {
                return { added: false, cart: currentCart };
              }

              return Promise.resolve($.ajax({
                type: 'POST',
                url: route('cart/add.js'),
                cartIncentiveRequest: true,
                data: JSON.stringify({
                  items: [{
                    id: variantId,
                    quantity: 1,
                    properties: {
                      _gift_product: 'yes',
                      _cart_incentive_gift: 'yes'
                    }
                  }]
                }),
                contentType: 'application/json; charset=UTF-8',
                dataType: 'json',
                headers: { 'X-Requested-With': 'XMLHttpRequest' }
              })).then(function () {
                var updatedCartRequest = $.isFunction(Shopify.requestFreshCart)
                  ? Shopify.requestFreshCart()
                  : getCart();

                return Promise.resolve(updatedCartRequest).then(function (updatedCart) {
                  return { added: true, cart: updatedCart };
                });
              });
            });
          }

          var addRequest = $.isFunction(Shopify.enqueueCartMutation)
            ? Shopify.enqueueCartMutation(performAdd)
            : performAdd();

          Promise.resolve(addRequest)
            .then(function (result) {
              if (!result.added) {
                isAddingGift = false;
                return;
              }

              var addedAt = getActiveGiftAddedAt() || Date.now();

              setStoredNumber(GIFT_ADDED_AT_KEY, addedAt);
              markOfferShown(addedAt);
              startGiftCountdown(addedAt);
              window.cartObj = result.cart;
              refreshCart(result.cart);
              isAddingGift = false;
            })
            .catch(function (xhr) {
              isAddingGift = false;
              console.warn(
                '[Cart incentive gift] Unable to add the gift.',
                getAjaxError(xhr, 'Please try again.')
              );
            });
        }

        if (isCartSnapshot(cart)) {
          submitGift(cart);
        } else {
          getCart()
            .done(submitGift)
            .fail(function () {
              isAddingGift = false;
            });
        }
      });
    }

    function inspectCart(cart) {
      var giftItems = getTargetGiftItems(cart);
      var addedAt;

      if (!giftItems.length) {
        addedAt = getActiveGiftAddedAt();

        if (!addedAt) removeStoredValue(GIFT_ADDED_AT_KEY);
        stopGiftCountdown();

        if (qualifiesForGift(cart) && !suppressedForPage && !isOfferFrequencyBlocked()) {
          addTargetGift(cart);
        }
        return;
      }

      addedAt = getStoredNumber(GIFT_ADDED_AT_KEY);
      if (!addedAt || Date.now() - addedAt >= GIFT_DURATION_IN_MS) {
        markOfferShown(addedAt || Date.now());
        removeTargetGift(cart, 'expired');
        return;
      }

      if (!qualifiesForGift(cart)) {
        removeTargetGift(cart, 'cart no longer qualifies', {
          suppress: false,
          clearAddedAt: false
        });
        return;
      }

      if (!getStoredNumber(OFFER_SHOWN_AT_KEY)) markOfferShown(addedAt);
      startGiftCountdown(addedAt);
    }

    function enforceGiftEligibility(cart) {
      if (isChecking || isAddingGift || isRemovingGift) return;

      isChecking = true;

      if (isCartSnapshot(cart)) {
        inspectCart(cart);
        isChecking = false;
        return;
      }

      getCart()
        .done(inspectCart)
        .fail(function (xhr) {
          console.warn('[Cart incentive gift] Unable to load the cart.', xhr);
        })
        .always(function () {
          isChecking = false;
        });
    }

    function scheduleGiftCheck(delay, cart) {
      if (checkTimer) window.clearTimeout(checkTimer);
      scheduledCart = isCartSnapshot(cart) ? cart : null;

      checkTimer = window.setTimeout(function () {
        var cartToInspect = scheduledCart;
        checkTimer = null;
        scheduledCart = null;
        enforceGiftEligibility(cartToInspect);
      }, Number(delay) || 0);
    }

    function declineGift(event) {
      var addedAt;

      event.preventDefault();

      if (isRemovingGift) return;

      addedAt = getStoredNumber(GIFT_ADDED_AT_KEY);
      suppressedForPage = true;
      markOfferShown(addedAt || Date.now());
      removeStoredValue(GIFT_ADDED_AT_KEY);
      stopGiftCountdown();

      // Normal cart rows keep the theme's own remove behavior. This handler only
      // records the decline so the qualifying cart does not add the gift again.
      if ($(event.currentTarget).is('[data-cart-remove]')) return;

      $(event.currentTarget).closest('[data-cart-incentive-gift]').addClass('is-loading');

      getCart()
        .done(function (cart) {
          removeTargetGift(cart, 'declined by customer');
        })
        .fail(function () {
          $('[data-cart-incentive-gift]').removeClass('is-loading');
        });
    }

    function trackGiftCheckout(event) {
      var $checkoutButton = $(event.currentTarget);
      var $cartContainer = $checkoutButton.is('#cart-sidebar-checkout')
        ? $('#halo-cart-sidebar')
        : $('[data-cart]');
      var giftSelector = '[data-cart-remove]' +
        '[data-handle="' + config.giftProductHandle + '"]' +
        '[data-cart-incentive-decline]' +
        '[data-free-gift="Yes"]';
      if (window.gtag && $cartContainer.find(giftSelector).length) {
        gtag('event', 'cart_incentive_gift_checkout');
      }
    }

    function isCartMutationUrl(url) {
      var requestUrl = String(url || '').split('?')[0];
      return /\/cart\/(add|change|update|clear)(?:\.js)?$/.test(requestUrl);
    }

    function observeFetchCartMutations() {
      var originalFetch;
      var wrappedFetch;

      if (!window.fetch || window.fetch.__goeliaCartIncentiveWrapped) return;

      originalFetch = window.fetch;
      wrappedFetch = function (input) {
        var requestUrl = input && input.url ? input.url : input;
        var request = originalFetch.apply(this, arguments);

        if (isCartMutationUrl(requestUrl)) {
          request.then(function (response) {
            if (!(response && response.ok)) return;

            lastAjaxCartMutationAt = Date.now();

            if (/\/cart\/(change|update|clear)(?:\.js)?(?:\?|$)/.test(String(requestUrl || ''))) {
              response.clone().json()
                .then(function (cart) {
                  scheduleGiftCheck(CART_MUTATION_DEBOUNCE_MS, cart);
                })
                .catch(function () {
                  scheduleGiftCheck(CART_MUTATION_DEBOUNCE_MS);
                });
            } else {
              scheduleGiftCheck(CART_MUTATION_DEBOUNCE_MS);
            }
          });
        }

        return request;
      };

      wrappedFetch.__goeliaCartIncentiveWrapped = true;
      window.fetch = wrappedFetch;
    }

    $document
      .on('click.cartIncentiveGift', '[data-cart-incentive-decline]', declineGift)
      .on('click.cartIncentiveGift', '#cart-checkout, #cart-sidebar-checkout', trackGiftCheckout)
      .on('cart:snapshot.cartIncentiveGift', function (event, cart) {
        if (checkTimer && !isChecking && !isAddingGift && !isRemovingGift && isCartSnapshot(cart)) {
          scheduleGiftCheck(0, cart);
        }
      })
      .on('cart:rerender.cartIncentiveGift', function (event, cart) {
        var eventCart = cart || (event.originalEvent && event.originalEvent.detail && event.originalEvent.detail.cart);

        // 近期 mutation 已安排检查时，仍允许完整 cart 替换原本需要再次请求的空快照。
        if (Date.now() - lastAjaxCartMutationAt < CART_RERENDER_DEDUP_MS && !isCartSnapshot(eventCart)) return;
        if (!isAddingGift && !isRemovingGift) scheduleGiftCheck(CART_MUTATION_DEBOUNCE_MS, eventCart);
      })
      .on('ajaxComplete.cartIncentiveGift', function (event, xhr, settings) {
        if (settings && settings.cartIncentiveRequest) return;
        if (!isCartMutationUrl(settings && settings.url)) return;

        lastAjaxCartMutationAt = Date.now();
        scheduleGiftCheck(CART_MUTATION_DEBOUNCE_MS, xhr && xhr.responseJSON);
      });

    observeFetchCartMutations();

    window.goeliaCartIncentive = {
      evaluate: enforceGiftEligibility,
      qualifiesForGift: qualifiesForGift,
      removeGift: function () {
        getCart().done(function (cart) {
          suppressedForPage = true;
          removeTargetGift(cart, 'manual API call');
        });
      }
    };

    enforceGiftEligibility(window.cartObj);
  });
})(jQuery);
